import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/CommandeAchat/';

export async function getEcheancierContrat(id) {
  const response = await HTTP.post(URL_BASE + 'PGetEcheancierContratAsync', { id: id });
  return response;
}

export async function getEcheancierContrats(ids) {
  const response = await HTTP.post(URL_BASE + 'PGetEcheancierContratsAsync', ids);
  return response;
}

export async function getAll(params) {
  const inputServer = generalTransformer(params);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function getAllEcheancier(params) {
  const inputServer = generalTransformer(params);
  const response = await HTTP.post(URL_BASE + 'PGetAllEcheancierAsync', inputServer);
  return response;
}

export async function getAllPaiements(id) {
  const response = await HTTP.post(URL_BASE + 'PGetAllPaiementsAsync', { id: id });
  return response;
}

export async function solderSansFacture(ids) {
  const response = await HTTP.post(URL_BASE + 'SolderSansFactureAsync', ids);
  return response;
}

export async function reactiverSuiteSoldeSansFacture(ids) {
  const response = await HTTP.post(URL_BASE + 'ReactiverSuiteSoldeSansFactureAsync', ids);
  return response;
}

export async function regenererCommandeAchat(ids) {
  const response = await HTTP.post(URL_BASE + 'RegenererCommandeAchatAsync', ids);
  return response;
}

export async function getAllCommandeAchat(params) {
  const inputServer = transform(params);
  const response = await HTTP.post(URL_BASE + 'PGetAllCommandeAchatBailleurAsync', inputServer);
  return response;
}

export async function get(commandeId) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: commandeId } });
  return response;
}

export async function sansSuite(id) {
  const response = await HTTP.post(URL_BASE + 'SansSuiteAsync', { id });
  return response;
}

export async function create(commande) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', commande);
  return response;
}

export async function update(commande) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', commande);
  return response;
}

export async function remove(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id } });
  return response;
}
